import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bg-sand)" }}>
        <p className="text-[var(--text-muted)]">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (role && user.role !== role && user.role !== "admin") {
    const fallback = user.role === "tradesperson" ? "/dashboard/trader" : "/dashboard/customer";
    return <Navigate to={fallback} replace />;
  }
  return children;
}
